import { useTranslation } from "react-i18next";import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../../contexts/ThemeContext';

export default function Footer() {const { t } = useTranslation();
  const { isDarkMode } = useTheme();
  return (
    <footer id="about" className={`relative z-10 ${isDarkMode ? 'bg-zinc-950 border-white/[0.06]' : 'bg-white border-black/[0.1]'} border-t overflow-hidden transition-colors duration-300`}>

            {/* ── CTA Block ── */}
            <div className={`px-5 sm:px-8 md:px-16 py-16 sm:py-24 md:py-36 border-b ${isDarkMode ? 'border-white/[0.06]' : 'border-black/[0.1]'}`}>
                <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-start lg:items-end justify-between gap-14">
                    <div>
                        <p className="text-[11px] font-medium text-red-600 tracking-[3px] uppercase mb-8 flex items-center gap-3">
                            <span className="w-6 h-px bg-red-700" />
                            {t("get_started")}
                        </p>
                        <h2
              className={`${isDarkMode ? 'text-white' : 'text-black'} font-light leading-[1.05] mb-6`}
              style={{ fontFamily: "'Instrument Serif', Georgia, serif", fontSize: 'clamp(2.5rem,5.5vw,5.5rem)' }}>
                            {t("take_control_of")}
              <br />
                            <span className={`italic ${isDarkMode ? 'text-white/55' : 'text-zinc-950'}`}>{t("your_entire_portfolio")}</span>
                        </h2>
                        <p className={`${isDarkMode ? 'text-white/70' : 'text-black'} font-light text-[15px] leading-relaxed max-w-md`}>
                            {t("hundreds_of_property_managers_have_alrea")}
                        
            </p>
                    </div>
                    <div className="flex flex-col gap-4 flex-shrink-0">
                        <Link
              to="/register"
              className={`inline-flex items-center gap-3 
                                ${isDarkMode ?
              'bg-white/5 border-white/10 text-white/50 hover:text-white/90 hover:border-white/20 hover:bg-white/10' :
              'bg-black/5 border-black/10 text-black/60 hover:text-black hover:border-black/25 hover:bg-black/10'}
                                text-[13px] font-normal tracking-[0.3px] px-8 py-3.5 rounded-full border backdrop-blur-md
                                transition-all duration-200 transform hover:-translate-y-0.5`}>
                            {t("start_free_trial")}
                            
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                                <path d="M2 7h10M8 3l4 4-4 4" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </Link>
                        <Link
              to="/login"
              className={`text-center text-[12px] font-light tracking-wide ${isDarkMode ? 'text-white/45 hover:text-white/75' : 'text-black/50 hover:text-black/80'} transition-colors`}>
                            {t("already_have_an_account")}
                        
            </Link>
                    </div>
                </div>
            </div>

            {/* ── Links ── */}
            <div className="px-5 sm:px-8 md:px-16 py-12 sm:py-16 max-w-7xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-8 sm:gap-12">

                {/* Brand */}
                <div className="col-span-2 md:col-span-1">
                    <Link to="/" className="flex items-center gap-2.5 mb-5 group">
                        <img
              src={isDarkMode ? "/quadcores-dark.png" : "/quadcores-light.png"}
              alt="Quadcores Properties"
              className="h-7 w-auto opacity-80 group-hover:opacity-100 transition-opacity" />
            
                        <span style={{ fontSize: 13.5, fontWeight: 400, color: isDarkMode ? 'rgba(255,255,255,0.8)' : 'rgba(0,0,0,0.85)', letterSpacing: '-0.2px', whiteSpace: 'nowrap' }}>
                            {t("quadcores_properties")}
                        </span>
                    </Link>
                    <p className={`${isDarkMode ? 'text-white/55' : 'text-zinc-950'} text-[13px] font-light leading-relaxed max-w-[200px] mb-6`}>
                        {t("the_apartment_management_platform_built")}
                    </p>
                </div>

                {/* Links */}
                {[
        { title: 'Platform', links: [['/#solutions', 'Solutions'], ['/features', 'Features'], ['/pricing', 'Pricing']] },
        { title: 'Company', links: [['/about', 'About'], ['/privacy', 'Privacy Policy'], ['/terms', 'Terms of Use']] },
        { title: 'Account', links: [['/register', 'Create account'], ['/login', 'Sign in'], ['/portal/tenant/login', 'Tenant Login'], ['/portal/owner/login', 'Owner Login']] }].
        map(({ title, links }) =>
        <div key={title}>
                        <p className={`text-[10px] font-medium ${isDarkMode ? 'text-white/55' : 'text-black/75'} tracking-[2px] uppercase mb-6`}>{title}</p>
                        <ul className="space-y-4">
                            {links.map(([href, label]) =>
            <li key={label}>
                                    {href.startsWith('/') ?
              <Link to={href} className={`text-[14px] ${isDarkMode ? 'text-white/70 hover:text-white/95' : 'text-black/85 hover:text-black/100'} font-light transition-colors`}>{label}</Link> :

              <a href={href} className={`text-[14px] ${isDarkMode ? 'text-white/30 hover:text-white/60' : 'text-black/85 hover:text-black/100'} font-light transition-colors`}>{label}</a>
              }
                                </li>
            )}
                        </ul>
                    </div>
        )}
            </div>

            {/* ── Bottom ── */}
            <div className={`px-5 sm:px-8 md:px-16 py-7 border-t ${isDarkMode ? 'border-white/[0.04]' : 'border-black/[0.06]'} flex flex-col sm:flex-row items-center justify-between gap-3 max-w-7xl mx-auto`}>
                <a href="https://www.quadcores.com/" target="_blank" rel="noopener noreferrer" className="text-[16px] text-red-700 hover:text-red-600 font-light transition-colors">{t("quadcores")}</a>
            </div>
        </footer>);

}